<script>
/**
 * Preloader component
 */
export default {
  data() {
    return {};
  },
  props: {
    loading: Boolean,
    showLoading: {
      default: true
    }
  },
  methods: {
    setLoading: function(visible) {
      // you can remove this settimeout method for production or integrating live API.
      document
        .getElementsByClassName("preloader-component")
        .forEach((elem) => {
          elem.style.display = visible ?  "none" : "";
        });
      document.getElementsByClassName("status").forEach((elem) => {
        elem.style.display = visible ? "none" : "";
      });
    },
  },
  watch: {
    /* eslint-disable no-console */
    // loading: function(newVal, oldVal) { // watch it
      loading: function(newVal) { // watch it

        // console.log(newVal);

        if(newVal) {
          setTimeout(() => {
            this.setLoading(newVal);
          }, 1000);
        } else {
          this.setLoading(newVal);
        }
      }
  },
};
</script>

<template>
  <div>
    <div v-if="showLoading == false"><slot /></div>
    <div v-else v-show="loading" :class="{ 'is-loading': loading }">
      <div class="preloader-component">
        <div class="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>